var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 .5A6.5 6.5 0 1013.5 7 6.507 6.507 0 007 .5zm2.084 6.872l-2.5 2.25a.5.5 0 11-.668-.744L8.002 7 5.916 5.122a.5.5 0 01.668-.744l2.5 2.25a.5.5 0 010 .744z","fill":"currentColor"}));
}

Arrow.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
